//请自行添加语言资源
const monthBill = {
  interfaceName: '接口名称',
  accountPeriod: '账单周期',
  carNums: '调用车辆数',
  callCount: '调用次数',
  cost: '费用金额（元）',
  msg: {}
};
export default monthBill



// WEBPACK FOOTER //
// ./src/page/bill/monthBill/lang/monthBill.zh.js